interface IProps {
    type: "sound" | "word" | "level";
    isB2cStudent?: boolean;
    onClick: () => void;
}

const TutorialButton = (props: IProps) => {
    const { onClick, type, isB2cStudent } = props;
    const isSound = type === "sound";

    const returnName = () => {
        if (type === "word") return "Word Position";
        if (isSound) return "Sound";
        if (type === "level") return "Level";
    };

    const renderPlayIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1}
            stroke="currentColor"
            className="w-7 h-7"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
            />
        </svg>
    );

    const renderBookIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            fill="currentColor"
            color="currentColor"
            className="w-6 h-6"
        >
            <path d="M560-564v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-600q-38 0-73 9.5T560-564Zm0 220v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-380q-38 0-73 9t-67 27Zm0-110v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-490q-38 0-73 9.5T560-454ZM260-320q47 0 91.5 10.5T440-278v-394q-41-24-87-36t-93-12q-36 0-71.5 7T120-692v396q35-12 69.5-18t70.5-6Zm260 42q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 102 12t96 36q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59ZM280-494Z" />
        </svg>
    );

    if (isSound && !isB2cStudent) return null;

    return (
        <div className="flex justify-center">
            <div
                className="flex items-center gap-2 cursor-pointer w-max bg-aha-light-blue border-black rounded-full py-1 px-3"
                onClick={onClick}
            >
                {isSound && isB2cStudent ? renderBookIcon() : renderPlayIcon()}

                <div className="text-sm">
                    {isSound && isB2cStudent ? (
                        "Speech Sound Screener"
                    ) : (
                        <>
                            60 sec{" "}
                            <p className="font-century-gothic-bold inline">
                                {returnName()}
                            </p>{" "}
                            tutorial
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TutorialButton;
